import { Component, Inject, Input, OnInit } from '@angular/core';
import { Timestamp } from '../../../../../models/timestamp';
import { DOCUMENT } from '@angular/common';
import { faArrowDown, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { TimestampMessages } from '../../../../shared/models/component-messages/timestamp-messages';
import { LogService } from '../../../../shared/services/log.service';

@Component({
  selector: 'app-timestamp',
  templateUrl: './timestamp.component.html',
  styleUrls: ['./timestamp.component.scss']
})
export class TimestampComponent implements OnInit {
  @Input() timestamp: Timestamp;
  @Input() timestampIndex;
  public arrowID: string;
  public isShow = true;
  public openById = {};
  public activeIds = ['first-panel'];
  public relatedInformation: string;
  public faArrowRight = faArrowRight;
  public faArrowDown = faArrowDown;
  public timestampMessages = new TimestampMessages();

  constructor(@Inject(DOCUMENT) private document: Document,private LOG: LogService) { }

  public ngOnInit() {
    this.arrowID = 'arrow_';
  }


  /**
   * return state of accordion, if accordion is open then it return true
   * @param eventTS get status of accordion
   */
  public isOpen(eventTS) {
    this.openById[eventTS.panelId] = eventTS.nextState;
    this.isShow = this.openById[eventTS.panelId];
  }

}
